<template>
  <div
    class="form-popup flex flex-row align-items-center"
    :class="{ show: isShow }"
    @click.self="config.allowClose ? closePopup() : null"
  >
    <div class="form-popup-content" :style="{ width: width }">
      <div
        class="form-popup-header d-flex justify-content-between align-items-center mb-2"
      >
        <h4 class="m-0">{{ title }}</h4>
        <i class="mdi mdi-close pointer" @click="close()" />
      </div>
      <div class="form-popup-body mb-2 p-2 overflow-auto" v-html="content" />
      <div class="form-popup-slot">
        <slot></slot>
      </div>
      <div class="text-center p-2" v-if="actions.length === 0">
        <button class="btn btn-primary px-5" @click="close()">Đóng</button>
      </div>
      <div class="text-center p-2" v-else>
        <button
          v-for="(action, index) in actions"
          :key="index"
          :class="
            action.className
              ? `btn btn-${action.className} px-5 mx-2`
              : 'btn btn-primary px-5 mx-2'
          "
          @click="action.onClick ? action.onClick() : close()"
        >
          {{ action.name || "Đóng" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      title: "",
      content: "",
      isShow: false,
      actions: [],
      width: "600px",
    }
  },

  watch: {
    "$route.path"() {
      this.closePopup()
    },
  },

  methods: {
    open(c) {
      this.openPopup(c)
    },
    openPopup(config = {}) {
      this.sending = false
      this.width = config.width || "600px"
      this.title = config.title || ""
      this.content = config.content || ""
      this.actions = config.actions || []
      this.functionListener = (e) => {
        if (e.key === "Escape") {
          this.closePopup()
        }
      }
      this.isShow = true

      document.addEventListener("keydown", this.functionListener)
    },
    closePopup() {
      this.isShow = false
      document.addEventListener("keydown", this.functionListener)
    },
    close() {
      this.closePopup()
    },
  },
}
</script>
